export const MAPBOX_TOKEN = "pk.eyJ1Ijoic2ltb24yMjEyIiwiYSI6ImNtZThpcHBobDBldnEybXM4ejV6dHNqY2EifQ.SbXFgvnPfpSk32G1C8bLTw"

// Google Maps browser keys (Google Cloud project reflex-osteo-gmb, Maps JavaScript API): public by design, each one
// locked to its sites by HTTP referrer. Production builds (production and staging) use the key of the site's domains;
// development and tests use one allowed on localhost only, so the production key never has to accept localhost.
export const GOOGLE_MAPS_API_KEYS = {
  production: "AIzaSyCFU-Js5XiwsE7XTG7RG-i5SkAADbqN9oo",
  development: "AIzaSyCKtIKjgbqH9RJCd0AZ9oFjroUILEbIXrU"
}

export function googleMapsApiKey (nodeEnv = process.env.NODE_ENV) {
  return nodeEnv === "production" ? GOOGLE_MAPS_API_KEYS.production : GOOGLE_MAPS_API_KEYS.development
}

export const GOOGLE_MAPS_API_KEY = googleMapsApiKey()
